var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Pane, MenuSection, Accordion, IconButton, AccordionSet, Icon, } from "@folio/stripes/components";
import { StripesConnectedSource, } from "@folio/stripes/smart-components";
import { FormattedMessage, useIntl } from "react-intl";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import UserDetail from "./UserDetail";
import { fetchUserById, fetchUsers } from "../../api/usersService";
import { fetchOrganizationData, fetchOrganizationOptions, } from "../../api/organizationService";
import { usePickerOptions } from "../../hooks/usePickerOptions";
import { PickerHint } from "../../components/PickerHint";
import { RecekTextField, RecekSelection } from "../../components/inputs";
import { hasRole, useActiveRoles } from "../../utils/permissionsUtils";
import { RoleEnum } from "../../types/RoleEnum";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { formatOrganizationName } from "../../utils/organizationUtils";
import { usePageSize } from "../../hooks/usePageSize";
var UsersList = function () {
    var _a;
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var activeRoles = useActiveRoles().roles;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(""), searchFilter = _b[0], setSearchFilter = _b[1];
    var _c = useState(""), organizationFilter = _c[0], setOrganizationFilter = _c[1];
    // const [archivedFilter, setArchivedFilter] = useState<boolean>(false);
    var _d = useState(null), selectedUser = _d[0], setSelectedUser = _d[1];
    var _e = useState({
        search: "",
        organization: "",
        // archived: false,
    }), filters = _e[0], setFilters = _e[1];
    var _f = useState(""), selectedOrg = _f[0], setSelectedOrg = _f[1]; // Holds selected user ID
    var _g = useState(0), pageOffset = _g[0], setPageOffset = _g[1];
    var _h = useState(0), totalRecords = _h[0], setTotalRecords = _h[1];
    var _j = usePageSize(function () {
        return setPageOffset(0);
    }), pageSize = _j.pageSize, handlePageSizeChange = _j.handlePageSizeChange;
    var _k = useState(""), name = _k[0], setName = _k[1];
    var _l = useState([]), organizations = _l[0], setOrganizations = _l[1];
    var handleOrganizationInput = function (inputValue) {
        setName(inputValue);
    };
    // DB-876: debounced, abortable search-as-you-type; a full page asks to refine the search
    var _m = usePickerOptions(name, function (term, signal) {
        return fetchOrganizationOptions(ky, term, signal).then(function (page) { var _a; return (_a = page.organizations) !== null && _a !== void 0 ? _a : []; });
    }), foundOrganizations = _m.options, organizationsLoading = _m.loading, organizationsTruncated = _m.truncated;
    // while nothing is typed, the organization preselected from the URL is the only option
    var organizationOptions = name ? foundOrganizations : organizations;
    var handleOrganizationSelection = function (selectedValue) {
        setSelectedOrg(selectedValue);
        setOrganizationFilter(selectedValue);
    };
    var _o = useState(true), filterPaneIsVisible = _o[0], setFilterPaneIsVisible = _o[1];
    // Derive filter/detail values from the URL. Keeping these as separate
    // primitives lets the effects below react only to the params they own, so
    // opening/closing the detail pane never clobbers the applied filters.
    var urlParams = new URLSearchParams(location.search);
    var searchParam = urlParams.get("search") || "";
    var organizationParam = urlParams.get("organization") || "";
    var detailParam = urlParams.get("detail");
    // Sync applied filter state from the URL. Reacts only to the search /
    // organization params, so navigating the detail pane does not reset filters.
    useEffect(function () {
        setFilters({
            search: searchParam,
            organization: organizationParam,
        });
        setSearchFilter(searchParam);
        setOrganizationFilter(organizationParam);
        setSelectedOrg(organizationParam);
        if (organizationParam) {
            var fetchFilteredOrganization = function () { return __awaiter(void 0, void 0, void 0, function () {
                var fetchedOrganization, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetchOrganizationData(organizationParam, ky)];
                        case 1:
                            fetchedOrganization = _a.sent();
                            setOrganizations([fetchedOrganization]);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error fetching organizations:", error_1);
                            setOrganizations([]);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            fetchFilteredOrganization();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParam, organizationParam]);
    // Open/close the detail pane based solely on the `detail` param, independent
    // of the applied filters.
    useEffect(function () {
        if (detailParam) {
            fetchUserById(ky, detailParam).then(function (user) {
                if (user) {
                    setSelectedUser(user);
                }
            });
        }
        else {
            setSelectedUser(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailParam]);
    var updateUrlWithFilters = function (filters) {
        var params = new URLSearchParams();
        if (filters.search)
            params.set("search", filters.search);
        if (filters.organization)
            params.set("organization", filters.organization);
        // if (filters.archived !== undefined) params.set('archived', filters.archived.toString());
        history.push({ search: params.toString() });
    };
    var handleClearFilters = function () {
        setPageOffset(0);
        setSearchFilter("");
        setSelectedOrg("");
        // setArchivedFilter(false);
        setFilters({
            search: "",
            organization: "",
            // archived: false,
        });
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () { return !!filters.search || !!filters.organization; };
    // Only send the organization filter when a privileged user explicitly picked
    // one from the dropdown. For a PublisherAdmin the backend now enforces the
    // cross-organization scope, so the frontend must not impose any org filter.
    var getEffectiveFilters = function () { return (__assign({}, filters)); };
    var _p = useQuery(["users", filters, pageOffset, pageSize], function () {
        return fetchUsers(ky, __assign(__assign({}, getEffectiveFilters()), { offset: pageOffset, limit: pageSize }));
    }, {
        onSuccess: function (data) {
            setTotalRecords(data.totalRecords);
        },
    }), data = _p.data, isLoading = _p.isLoading, isError = _p.isError, isFetched = _p.isFetched;
    var usersData = (_a = data === null || data === void 0 ? void 0 : data.users) !== null && _a !== void 0 ? _a : [];
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var columns = [
        {
            name: "Příjmení",
            key: "lastName",
            clickable: true,
            onClick: function (item) {
                var currentParams = new URLSearchParams(location.search);
                currentParams.delete("detail");
                currentParams.set("detail", item.id);
                history.push({
                    search: currentParams.toString(),
                });
                setSelectedUser(item);
            },
        },
        {
            name: "Jméno",
            key: "firstName",
        },
        {
            name: "E-mail",
            key: "email",
        },
        {
            name: "Organizace",
            key: "id",
            cellRenderer: function (item) {
                var _a;
                // DB-890: the list response carries each user's organizations, no request per row
                var orgs = (_a = item.organizations) !== null && _a !== void 0 ? _a : [];
                if (!orgs.length)
                    return "N/A";
                return orgs.map(function (userOrg, idx) {
                    var organization = userOrg.organization;
                    var name = formatOrganizationName(organization);
                    var label = organization.archived ? (React.createElement("span", { style: { textDecoration: "line-through" } }, name)) : (name);
                    return (React.createElement(React.Fragment, { key: organization.id },
                        label,
                        idx < orgs.length - 1 ? ", " : ""));
                });
            },
        },
    ];
    var source = new StripesConnectedSource({}, ky);
    source.update = function () { };
    source.records = function () { return usersData; };
    source.resultCount = function () { return totalRecords; };
    source.totalCount = function () { return totalRecords; };
    source.pending = function () { return isLoading; };
    source.loaded = function () { return isFetched; };
    source.failure = function () { return (isError ? { message: "Error loading data" } : null); };
    source.failureMessage = function () { return "Error loading data"; };
    source.successfulMutations = function () { return []; };
    source.fetchMore = function () { return setPageOffset; };
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-users.navigation.pane.title",
            }), lastMenu: filterPaneIsVisible ? (React.createElement(IconButton, { icon: "caret-left", onClick: toggleFilterPane, "aria-label": filterPaneIsVisible ? "Skrýt filters" : "Show filters", style: { marginLeft: "auto" } })) : (React.createElement(React.Fragment, null)) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(Icon, { icon: "times-circle-solid" }, formatMessage({
                        id: "ui-br-users.users.button.content.resetAll",
                    }))),
                React.createElement(AccordionSet, null,
                    React.createElement("form", { onSubmit: function (event) {
                            event.preventDefault();
                            var payload = __assign(__assign({}, filters), { search: searchFilter, organization: organizationFilter });
                            setPageOffset(0);
                            setFilters(payload);
                            updateUrlWithFilters(payload);
                        } },
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-users.usersList.accordion.label.search",
                            }), separator: false },
                            React.createElement(RecekTextField, { labelId: "ui-br-users.usersList.textField.label.search", showLabel: false, placeholder: formatMessage({
                                    id: "ui-br-users.usersList.textField.placeholder.search",
                                }), value: searchFilter, onChange: function (e) { return setSearchFilter(e.target.value); } })),
                        (hasRole(activeRoles, RoleEnum.SUPERUSER) ||
                            hasRole(activeRoles, RoleEnum.AGENCY_WORKER) ||
                            hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS) ||
                            !hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN)) && (React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-users.users.detail.accordion.label.organizations",
                            }), separator: false },
                            React.createElement(RecekSelection, { labelId: "ui-br-users.usersList.textField.label.organizations", showLabel: false, name: "orgSelection", value: selectedOrg, loading: organizationsLoading, onChange: handleOrganizationSelection, asyncFilter: true, onFilter: handleOrganizationInput, dataOptions: organizationOptions.map(function (org) { return ({
                                    value: org.id,
                                    label: org.name,
                                }); }) }),
                            React.createElement(PickerHint, { truncated: organizationsTruncated }),
                            selectedOrg && (React.createElement(Button, { buttonStyle: "none", id: "clickable-clear-organization", marginBottom0: true, onClick: function () { return handleOrganizationSelection(""); } },
                                React.createElement(Icon, { icon: "times-circle-solid" }, formatMessage({
                                    id: "ui-br-users.usersList.button.clearOrganization",
                                })))))),
                        React.createElement(Button, { type: "submit", marginBottom0: true }, formatMessage({
                            id: "ui-br-users.button.apply",
                        }))))))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-users.usersList.pane.title.usersList",
            }), paneSub: formatMessage({ id: "ui-br-users.table.subtitle.records-found" }, { count: totalRecords }), actionMenu: function (_a) {
                var onToggle = _a.onToggle;
                return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" }, (hasRole(activeRoles, RoleEnum.AGENCY_WORKER) ||
                    hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN) ||
                    hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS)) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        onToggle();
                        history.push("/brusers/users/create");
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.new" })))));
            }, firstMenu: !filterPaneIsVisible ? (React.createElement(IconButton, { icon: "caret-right", onClick: toggleFilterPane, "aria-label": filterPaneIsVisible ? "Hide filters" : "Show filters", style: { marginLeft: "auto" } })) : (React.createElement(React.Fragment, null)) },
            React.createElement(TableComponent, { data: usersData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: totalRecords, pagingOffset: pageOffset, onNeedMoreData: setPageOffset, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source })),
        selectedUser ? (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-users.users.pane.title.detail",
            }), onClose: function () {
                setSelectedUser(null);
                var queryParams = new URLSearchParams(location.search);
                queryParams.delete("detail");
                history.replace({ search: queryParams.toString() });
            }, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                (hasRole(activeRoles, RoleEnum.AGENCY_WORKER) ||
                    hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN) ||
                    hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS)) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        return history.push("/brusers/users/edit/".concat(selectedUser.id));
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.edit" }))),
                (hasRole(activeRoles, RoleEnum.AGENCY_WORKER) ||
                    hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN) ||
                    hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS)) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        return history.push("/brusers/users/reset/".concat(selectedUser.id));
                    }, fullWidth: true },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.resetPassword" }))))); } },
            React.createElement(UserDetail, { user: selectedUser }))) : null));
};
export default UsersList;
